import { live } from '../data/live';
import { schedule } from '../data/schedule';
import { inforoll } from '../renderers/inforoll';
import { donationsRenderer } from '../renderers/donations-renderer';
import { currentRunRenderer } from '../renderers/current-run-renderer';
import { breakScheduleRenderer } from '../renderers/break-schedule-renderer';
import { breakIncentivesRenderer } from '../renderers/break-incentives-renderer';
import { logoCrossFade } from '../renderers/logo-crossfade';
// Imported but never called: the clinic segments are dormant. Keeping the import means
// parcel still compiles them, so a rename elsewhere breaks the build instead of rotting
// silently until someone tries to revive it.
import '../clinic';
import { flagRenderer } from '../renderers/flag-renderer';
import { cycle } from '../cycle';
import { breakCarousel } from '../break-carousel';
import { jukebox } from '../audio/jukebox';

// STRAPI

setTimeout(live.fetchGufInfo, 200);
setTimeout(live.fetchGufInfo, 3000);
setInterval(live.fetchGufInfo, 15000);

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const debug = urlParams.get('debug') === 'true' || false;
const debugDonationFrequency = parseInt(urlParams.get('debugDonationFrequency') || 1000);
const debugDonationMaxXSpawn = parseInt(urlParams.get('debugDonationMaxXSpawn') || 100);
window.debugDonationMaxXSpawn = debugDonationMaxXSpawn;

const stopLoop = urlParams.get('stopLoop') === 'true' || false;
console.log("Looping is", !stopLoop ? "enabled" : "disabled");
window.stopLoop = stopLoop;

const showControls = urlParams.get('showControls') === 'true' || false;
window.showControls = showControls;

if (showControls) {
    document.getElementById("debug-controls").classList.remove("hide");
}

// Wired here rather than as inline onclick=, which needed the renderers to be on
// window at parse time. They still are, for the devtools console, but the page no
// longer depends on it.
const debugButtons = {
    'advance-infobar': () => inforoll.start(),
    'show-donation-goal': () => donationsRenderer.showDonationGoalProgressBar(),
    'show-red': () => flagRenderer.showRed(),
    'show-white': () => flagRenderer.showWhite(),
    'show-green': () => incentiveFlag.showGreen(),
};
Object.entries(debugButtons).forEach(([id, handler]) => {
    document.getElementById(id)?.addEventListener('click', handler);
});

if (!stopLoop)
    live.callWhenReady(cycle.start);

// OENGUS
setInterval(function() {
    schedule.updateCurrentTime();
}, 3000);

live.callWhenReady(schedule.refreshSchedule);
// every poll: the backend reprojects the remaining slots when staff close one out
live.callWhenUpdated(schedule.refreshSchedule);
live.callWhenUpdated(schedule.showSchedulePreview);
live.callWhenUpdated(live.parseIncentives);

// The break screen's carousel runs independently of the infobar cycle. It needs ads and
// incentives, not the schedule, so it hangs off the poll *after* parseIncentives —
// callWhenRefreshed fires earlier in the same poll, when live.incentives is still
// empty, and the carousel would idle a full recheck before showing anything. start() is
// idempotent, so this means "as soon as there is data" without a flag of its own.
live.callWhenUpdated(breakCarousel.start);

// The ISC logo / #GUFA26 crossfade is independent of everything else.
logoCrossFade.fadeInLogo('isc-logo');

// RENDERERS
live.callWhenReady(function () {
    currentRunRenderer.fadeInOutRunnerName(1);
    currentRunRenderer.fadeInOutRunnerName(2);
    setTimeout(breakScheduleRenderer.startFizzleWatcher, 5000);
    donationsRenderer.startDonationLeaderboardToggleLoop();
    donationsRenderer.showBreakDonationContainer();
});
live.callWhenUpdated(donationsRenderer.updateDonations);
live.callWhenUpdated(donationsRenderer.updateDonatorsLeaderboard);
live.callWhenUpdated(donationsRenderer.updateDonationLeaderboard);
live.callWhenUpdated(donationsRenderer.updateDonationReason);
live.callWhenUpdated(donationsRenderer.maybeUpdateDonationGoal);
live.callWhenUpdated(currentRunRenderer.updateHostName);
live.callWhenUpdated(currentRunRenderer.updateBreakScreenHost);
live.callWhenUpdated(donationsRenderer.maybeShowLeaderboard);

// Only when the derived schedule actually moves
schedule.callWhenRefreshed(currentRunRenderer.updateRunnerName);
schedule.callWhenRefreshed(currentRunRenderer.updateCurrentRunInfo);
schedule.callWhenRefreshed(currentRunRenderer.updateCouch);
schedule.callWhenRefreshed(breakScheduleRenderer.updateAndShowAllBreakRuns);

// AUDIO — inert without ?bgm=true
live.callWhenReady(jukebox.setUp);
live.callWhenReady(jukebox.scrollBgmLoop);